module.exports = __webpack_public_path__ + "static/media/MentalModel.240b6ecd.png";